import { useEffect, useRef, useState } from "react";
import mapboxgl from "mapbox-gl";
import { mapConfig } from "../../config/map-config";
import { useAppContext } from "../../services/context/app-context";
import { getCentroidCoordinates } from "../../utils/map-labels";

export function useMapbox() {
  const { property } = useAppContext();
  const mapContainerRef = useRef(null);
  const [map, setMap] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  /* const [searchResult, setSearchResult] = useState(null); */
  /* const [mapStyle, setMapStyle] = useState(initialStyle); */

  const coordinates = property
    ? getCentroidCoordinates(property.propertyGeoJSON?.features[0])
    : null;

  useEffect(() => {
    if (!map && mapContainerRef.current) {
      mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

      const initializedMap = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: "mapbox://styles/mapbox/standard",
        /*  style: 'mapbox://styles/mapbox/light-v11', */
        center: coordinates ? coordinates : mapConfig.defaultCenter,
        zoom: property ? 17 : mapConfig.defaultZoom,
        pitch: 0,
        bearing: 0,
        antialias: true,
        projection: mapConfig.defaultProjection,
        attributionControl: false, // hide © Mapbox © OpenStreetMap Improve this map
      });

      // display '© Mapbox © OpenStreetMap Improve this map' in compact form
      initializedMap.addControl(
        new mapboxgl.AttributionControl({
          compact: true,
        }),
        "bottom-right",
      );

      initializedMap.addControl(new mapboxgl.ScaleControl());

      initializedMap.on("load", () => {
        // hide default mapbox labels
        initializedMap.setConfigProperty(
          "basemap",
          "showPointOfInterestLabels",
          false,
        );
        setMap(initializedMap);
        setMapLoaded(true);

        /*  initializedMap.addLayer(
          {
            id: 'add-3d-buildings',
            source: 'composite',
            'source-layer': 'building',
            filter: ['==', 'extrude', 'true'],
            type: 'fill-extrusion',
            minzoom: 15,
            paint: {
              'fill-extrusion-color': '#aaa',
              'fill-extrusion-height': [
                'interpolate',
                ['linear'],
                ['zoom'],
                15,
                0,
                15.05,
                ['get', 'height']
              ],
              'fill-extrusion-base': [
                'interpolate',
                ['linear'],
                ['zoom'],
                15,
                0,
                15.05,
                ['get', 'min_height']
              ],
              'fill-extrusion-opacity': 0.6
            }
          },
        ); */
      });
    }

    // Cleanup on unmount
    return () => {
      if (map) {
        map._controls.forEach((control) => map.removeControl(control));
        map.remove();
      }
    };
  }, [map]);

  return {
    mapContainerRef,
    map,
    mapLoaded,
  };
}
